import { faFolderBookmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu } from '@nexelem/components';
import { openSavedViewsDrawer } from './SavedViewsDrawer';
import { useTableName } from '../../utils';
import { selectSavedViews, useSaveViewStore } from '../SaveViewStore';
import { useTableTranslation } from '../../translations';

export const SavedViewButton = () => {
  const { t } = useTableTranslation();
  const tableName = useTableName();
  const savedViews = useSaveViewStore(selectSavedViews(tableName));

  return (
    <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faFolderBookmark} />} onClick={() => openSavedViewsDrawer()}>
      {t('savedViews')} ({savedViews.length})
    </DropdownMenu.Button>
  );
};
